/*
 * SecondLap — lien « Retour à la boutique ».
 * Suivre le lien serait une navigation vers l'avant : la collection reviendrait
 * en haut, avec une seule page de produits. Quand le visiteur arrive justement
 * d'une page collection, on déclenche un vrai retour arrière — le navigateur
 * restitue alors sa page telle qu'il l'avait laissée, filtres, produits chargés
 * et position de défilement compris, sans aucune requête.
 * Dans tous les autres cas (arrivée directe, moteur de recherche, autre fiche
 * produit), le lien se comporte normalement.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-sl-back]');
  if (!link) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
  if (!document.referrer || history.length <= 1) return;

  let origine;
  try {
    origine = new URL(document.referrer);
  } catch (error) {
    return;
  }

  const memeSite = origine.origin === window.location.origin;
  const vientDUneCollection = origine.pathname.startsWith('/collections/');
  if (!memeSite || !vientDUneCollection) return;

  event.preventDefault();
  history.back();
});
